import React, { Suspense, useMemo } from 'react'
import { PropsOf } from '@rst/libs-ts'
import { useStore } from 'effector-react'

import { CtxType, footerCxt } from './ctx'
import { LanguageProps } from '../common/lang-selector'
import { ModalMap } from './features/map-modal'
import { ModalRequest } from './features/request-modal'
import { createDelayImport } from '../../lib/delay'

type FooterPropsType = React.FC<{
	ctx: CtxType
	FooterWrapper?: (props: { children: React.ReactNode }) => JSX.Element | null
	langProps: LanguageProps | null
}>

export const FooterCtx = createDelayImport(
	() =>
		/*  webpackMode: "lazy"*/
		import('./features/footer').then(x => {
			return x.FooterCtx
		}),
	2000,
	'footer'
)
const CustomFooter = createDelayImport(
	() =>
		import('./features/custom-footer').then(x => {
			return x
		}),
	2000,
	'footer'
)

const Footer: FooterPropsType = ({ ctx, FooterWrapper, langProps }) => {
	const footer = useStore(ctx.$footer)

	const FooterComponent = useMemo(
		() => (footer?.type === 'custom' ? CustomFooter : FooterCtx),
		[footer?.type]
	)

	const Wrapper = useMemo(
		() => FooterWrapper || React.Fragment,
		[FooterWrapper]
	)

	return (
		<footerCxt.Provider value={ctx}>
			<Wrapper>
				<Suspense fallback={null}>
					<FooterComponent
						langProps={langProps}
						footer={footer as PropsOf<typeof FooterComponent>['footer']}
					/>
				</Suspense>
			</Wrapper>
			<ModalRequest />
			<ModalMap />
		</footerCxt.Provider>
	)
}

export { Footer }
export { CustomFooterItemPreview } from './features/custom-footer'
